import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const RouterProvider = lazy(() => import('@app/components/RouterProvider'))

const AuthRouter = lazy(() => import('./AuthRouter'))

class OnboardingRouterWebComponent extends ReactWebComponent {
  override render() {
    return (
      <PageRoot>
        <RouterProvider>
          <AuthRouter />
        </RouterProvider>
      </PageRoot>
    )
  }
}

customElements.define('auth-router', OnboardingRouterWebComponent)
